const config = require("./config");

module.exports = {
    data: require("./api.net.data"),
    converter: require("./api.net.converter"),
    config,
};


// WEBPACK FOOTER //
// src/utils/api/net/index.js